import React, { useState } from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { Button } from './ui/button';
import { faqs } from '../mock';
import { ChevronDown, ChevronUp } from 'lucide-react';

export const FAQ = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedFaqs = showAll ? faqs : faqs.slice(0, 4);

  return (
    <section className="py-16 md:py-20 bg-gradient-to-br from-slate-50 via-white to-purple-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Frequently Asked
            <span className="block bg-gradient-to-r from-purple-600 to-orange-600 bg-clip-text text-transparent mt-2">
              Questions
            </span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Got questions? We&apos;ve got answers. Find everything you need to know about our courses.
          </p>
        </div>

        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-6">
          {displayedFaqs.map((faq, idx) => (
            <div key={idx} className="bg-white rounded-xl shadow-md border border-slate-200 hover:shadow-lg transition-all duration-300">
              <Accordion type="single" collapsible>
                <AccordionItem value={`item-${idx}`} className="border-none">
                  <AccordionTrigger className="text-left text-base font-bold text-slate-900 hover:text-purple-600 px-5 py-4 hover:no-underline">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed px-5 pb-4 text-sm">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          ))}
        </div>

        {/* View More / View Less Button */}
        {faqs.length > 4 && (
          <div className="text-center mt-10">
            <Button
              onClick={() => setShowAll(!showAll)}
              className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-8 py-6 text-base rounded-full shadow-lg transform hover:scale-105 transition-all duration-300 border-0"
            >
              {showAll ? (
                <>
                  <ChevronUp className="mr-2 h-5 w-5" />
                  View Less FAQs
                </>
              ) : (
                <>
                  <ChevronDown className="mr-2 h-5 w-5" />
                  View More FAQs
                </>
              )}
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};